var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('language-switcher',{staticClass:"switcher",scopedSlots:_vm._u([{key:"default",fn:function({ links }){return _vm._l((links),function(link){return _c('router-link',{key:link.langIndex,staticClass:"nea-link",attrs:{"to":link.url}},[_c('span',[_vm._v(_vm._s(link.langName))])])})}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }